/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type WrapperQueryListChatActivities_EmbedQueryVariables = {};
export type WrapperQueryListChatActivities_EmbedQueryResponse = {
    readonly " $fragmentRefs": FragmentRefs<"TabsChatActivities_EmbedQuery">;
};
export type WrapperQueryListChatActivities_EmbedQuery = {
    readonly response: WrapperQueryListChatActivities_EmbedQueryResponse;
    readonly variables: WrapperQueryListChatActivities_EmbedQueryVariables;
};



/*
query WrapperQueryListChatActivities_EmbedQuery {
  ...TabsChatActivities_EmbedQuery
}

fragment BadgeChatActivityUnassigned_EmbedViewer on User {
  countUnassigned: chatActivityUnassignedCount
}

fragment TabsChatActivities_EmbedQuery on Query {
  viewer {
    ...BadgeChatActivityUnassigned_EmbedViewer
    id
  }
}
*/

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WrapperQueryListChatActivities_EmbedQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "TabsChatActivities_EmbedQuery"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WrapperQueryListChatActivities_EmbedQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "countUnassigned",
            "args": null,
            "kind": "ScalarField",
            "name": "chatActivityUnassignedCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b9f6bbfdc5a55e097a620cdbb3cbe031",
    "id": null,
    "metadata": {},
    "name": "WrapperQueryListChatActivities_EmbedQuery",
    "operationKind": "query",
    "text": "query WrapperQueryListChatActivities_EmbedQuery {\n  ...TabsChatActivities_EmbedQuery\n}\n\nfragment BadgeChatActivityUnassigned_EmbedViewer on User {\n  countUnassigned: chatActivityUnassignedCount\n}\n\nfragment TabsChatActivities_EmbedQuery on Query {\n  viewer {\n    ...BadgeChatActivityUnassigned_EmbedViewer\n    id\n  }\n}\n"
  }
};
(node as any).hash = '830b6d650fa00003f2e828dd39381379';
export default node;
